<template>
  <el-dialog :visible.sync="show" title="三元详细信息" :before-close="closeDialog" width="900px" :close-on-click-modal="false" append-to-body>
    <div class="" v-loading="loading">
      <el-form label-width="120px" :inline="true" ref="form">
        <el-form-item label="设备名" prop="Name">
          <el-input class="input-small" v-model="triplet.extendParam" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="出厂编码" prop="Name">
          <el-input class="input-small" v-model="triplet.FactoryCode" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="资产码" prop="Name">
          <el-input class="input-small" v-model="triplet.assetsCode" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>
        <el-form-item label="设备密钥" prop="Name">
          <el-input class="input-small" v-model="triplet.SecrtKey" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-form-item label="产品密钥" prop="Name">
          <el-input class="input-small" v-model="triplet.PublickKey" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-form-item label="产品密钥" prop="Name">
          <el-input class="input-small" v-model="triplet.PublickKey" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-form-item label="注册码" prop="Name">
          <el-input class="input-small" v-model="triplet.RegCode" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-form-item label="交直流类型" prop="Name">
          <el-input class="input-small" v-model="triplet.TypeName" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-form-item label="通讯协议" prop="Name">
          <el-input class="input-small" :value="triplet.dev_type == 1 ? '云快充' : '国网'" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-form-item label="创建时间" prop="Name">
          <el-input class="input-small" v-model="triplet.CreateTime" :disabled="isDisabled" style="width: 280px"></el-input>
        </el-form-item>

        <el-table :data="gunStates" border size="medium" style="width: 88%; margin-bottom: 20px; margin-left: 50px" :header-cell-style="{ background: '#f5f7fa', color: '#606266' }" highlight-current-row>
          <el-table-column prop="gun_no" label="枪号" align="center" width="250"></el-table-column>
          <el-table-column prop="eis_start_name" label="状态" align="center"></el-table-column>
          <el-table-column prop="realPower_text" label="功率" align="center"></el-table-column>
          <el-table-column prop="last_time" label="最新时间" align="center"></el-table-column>
        </el-table>
        <div class="flex-end mt-10">
          <el-button @click="closeDialog">关闭</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import { GetTripletByAssetsCode } from "@/api/dev_archive.js"

import { formatDate } from "@/utils/tools.js"
import { Row } from "element-ui"
export default {
  data() {
    return {
      show: false,
      loading: false,
      isDisabled: true,
      triplet: {},
      detailsActiveName: "充电枪",
      gunStates: []
    }
  },
  props: {},
  watch: {},
  methods: {
    showTripletInfo(assets_code) {
      this.show = true
      this.loading = true
      GetTripletByAssetsCode({ assetsCode: assets_code }).then((res) => {
        this.triplet = res.data
        this.gunStates = res.data.gunStates
        console.log(this.gunStates)
        this.loading = false
      })
    },

    closeDialog() {
      this.show = !this.show
    }
  }
}
</script>
